import React, { useContext, useEffect, useState } from 'react'
import { withRouter, useParams } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'
import strings from '../../lang/strings'
import { observer } from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import { MaleUrl, PAGECOUNT } from '../../config/const'
import StarRatingCustom from '../../components/control/star_rating'
import TabHeader from '../../components/control/table/tab_header'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import ItemProduct from '../../components/item/item_product'
import ConfirmButton from '../../components/control/button/confirm_button'
import PerfectScrollbar from 'react-perfect-scrollbar'
import ReactPaginate from 'react-paginate'
import { customDateFormat, drawTableBJPointCell, drawTableTitleCell, drawTableArticleType, formatNumber, fphoto, string } from '../../helper/common'
import tbAnalystHeaders, { tbBjHeaders, tbDailyHeaders, tbGameHeaders, tabInfo } from '../../config/constTable'
import { rootStore } from '../../mobx/store'
import TableCellGameCate from '../../components/control/table/table_cell_game_cate'
import { RESULT_CODE } from '../../config/const'
import { htmlToText } from '../../helper/common'
import { BjTableRows, DailyTableRows } from '../../components/table/winee_table'
import MetaTags from '../../components/metatags/metatags'
import { requestBjDataBuy } from '../../helper/business'
import useIsMobile from '../../hooks/useIsMobile'
import { BjTableCard } from '../../components/card/winee_card'


const BjDetail = observer((props) => {
  const { bj_id } = useParams();
  let { bjList = [] } = props.location.state || {};
  const context = useContext(Page_settings)
  const [loaded, setLoaded] = useState(false);
  let [mbInfo, setMbInfo] = useState({})
  let [tabIndex, setTabIndex] = useState(0)
  const tabList = [tabInfo.bjGameArticle]
  let [dataList, setDataList] = useState(Array.from({ length: tabList.length }, () => []))
  let [pageCount, setPageCount] = useState(Array.from({ length: tabList.length }, () => 1))
  let [page, setPage] = useState(Array.from({ length: tabList.length }, () => 1))
  let [itemList, setItemList] = useState([])
  let [itemIndex, setItemIndex] = useState(0)
  const [unlimitedViewPeriods, setUnlimitedViewPeriods] = useState([]);
  let [type, setType] = useState(0);
  let [selBj, setSelBj] = useState(0)
  let [memberList, setMemberList] = useState(bjList)

  const isMobile = useIsMobile();


  useEffect(() => {
    context.post('data/bj_list', { bj_id: bj_id },
      response => {
        const mb = response.bj
        if (mb) {
          if (bjList.length == 0) {
            bjList = response.bj_list
            setMemberList(bjList);
          }
          setInfo(mb)
          setLoaded(true);
        } else {
          props.history.replace('/bj/list')
        }
      }
    )

  }, [])

  useEffect(() => {
    setProduct(bj_id);
    setUnlimitedView(bj_id);
  }, [bj_id]);

  useEffect(() => {
    if (!mbInfo || !mbInfo.mb_id) return;
    getData(mbInfo.mb_id, 1, tabIndex)
    if (tabList[tabIndex].table_type !== "daily") return
    context.checkDailyPopup()
  }, [tabIndex, mbInfo])


  const setProduct = (bj_id) => {
    const requestData = {
      member_id: bj_id
    };

    // 서버로 요청 보내기
    context.post(
      'product/get_product_list',
      requestData,
      (response) => {
        if (response.products && response.products.length > 0) {
          setItemList(response.products);
        } else {
          setItemList([]);
        }
      },
      true,
      (err) => {
        context.showAlert(err.msg);
      }
    );
  }

  const setUnlimitedView = (bj_id) => {
    context.post('product/get_unlimited_view_date', { bj_id: bj_id },
      response => {
        if (response.periods && response.periods.length > 0) {
          setUnlimitedViewPeriods(response.periods[0]);
        } else {
          setUnlimitedViewPeriods(null);
        }
      },
      true,
      err => {
      }
    )
  }

  const setInfo = (info) => {
    setSelBj(info?.mb_id ?? 0)
    setMbInfo(info)
    setType(Number(info.mb_lv - 4))
    context.post('data/bj_ticket_cnt', { mb_id: info.mb_id },
      response => {
        let ticket = response.readable_cnt
        info.readable_cnt = ticket
        setMbInfo(info)
        setReadableCnt(ticket)
      },
      false,
      err => {
        if (err.result !== RESULT_CODE.TOKEN_EXPIRED)
          setTimeout(() => { context.showAlert(err.msg) }, 500)
      }
    )

    // let itList = []
    // if (info.price01 > 0) itList.push({ it_id: 1, it_name: strings.one_day_package, it_price: info.price01 })
    // if (info.price10 > 0) itList.push({ it_id: 10, it_name: strings.ten_day_package, it_price: info.price10 })
    // if (info.price20 > 0) itList.push({ it_id: 20, it_name: strings.twenty_day_package, it_price: info.price20 })
    // if (info.price30 > 0) itList.push({ it_id: 30, it_name: strings.thirty_day_package, it_price: info.price30 })
    // setItemList(itList)
  }

  const getData = (mb_id, page, index) => {
    const cate = tabList[index].cate
    context.post('data/data_list', { mb_id: mb_id, cate: cate, page: page, count: PAGECOUNT },
      response => {
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
        setDataList(prev => prev.map((it, idx) => { return idx === index ? response.list : it }))
        setPageCount(prev => prev.map((it, idx) => { return idx === index ? response.page_count : it }))
      },
      false
    )
  }

  const onLike = () => {
    const status = 1 - mbInfo.mb_is_like
    context.onLike(mbInfo, status, true, () => {
      setMbInfo({ ...mbInfo, mb_is_like: status })
    })
  }

  const setReadableCnt = (cnt) => {
    setMbInfo(prev => ({
      ...prev,
      readable_cnt: cnt
    }));

    setMemberList(prev => prev.map((it) => {
      if (it.mb_id == mbInfo.mb_id) it.readable_cnt = cnt
      return it
    }))
  }


  const onBuyItem = () => {
    if (!rootStore.isSignedIn) {
      props.history.push('/login')
      return
    }
    const item = itemList[itemIndex]
    if (item.it_price == 0) return
    context.showConfirm(strings.ask_package, (val) => {
      if (!val) return
      const mb_point = rootStore.getMe.mb_point
      if (Number(mb_point) < Number(item.it_price)) {
        context.showPointLack(2, item.it_price, () => {
          context.showPointPay()
        })
        return
      }
      context.post('pay/bj_buy', { bj_id: mbInfo.mb_id, limit: item.it_id },
        response => {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
          setReadableCnt(response.readable_cnt)
          setTimeout(() => { context.showAlert(strings.package_bought) }, 500)
        },
        true,
        err => {
          setTimeout(() => { context.showAlert(err.msg) }, 500)
        }
      )
    })
  }

  const onBuyProduct = (product) => {
    if (!rootStore.isSignedIn) {
      props.history.push('/login')
      return
    }
    context.showConfirm(strings.ask_package, (val) => {
      if (!val) return
      const mb_point = rootStore.getMe.mb_point
      if (Number(mb_point) < Number(product.price)) {
        context.showPointLack(2, product.price, () => {
          context.showPointPay()
        })
        return
      }
      context.post('product/purchase_product', { mp_id: product.id },
        response => {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          setUnlimitedViewPeriods(response.periods[0]);
          rootStore.signIn(mb)
          getData(mbInfo.mb_id, 1, tabIndex)
          setTimeout(() => { context.showAlert(strings.package_bought) }, 500)
        },
        true,
        err => {
          setTimeout(() => { context.showAlert(err.msg) }, 500)
        }
      )

    })
  }

  const goResult = (result) => {
    props.history.push(tabList[tabIndex].url, { result: result })
  }

  const goPreview = (dat_no) => {
    props.history.push('/bj/bj_result', { result: { dat_id: dat_no } })
  }

  const onResultAnalyst = (result, price) => {
    if (!rootStore.isSignedIn) {
      props.history.push('/login')
      return
    }

    if (result.is_readable == 0) {
      context.showAlert(strings.data_disabled)
      return
    }

    if (result.is_purchased == 0) {
      if (result.is_free == 1) {
        context.post('pay/andata_buy', { dat_id: result.dat_id },
          response => {
            let mb = rootStore.getMe
            mb.mb_point = response.mb_point
            rootStore.signIn(mb)
            goResult(result)
          },
          true,
          err => {
            setTimeout(() => { context.showAlert(err.msg) }, 500)
          }
        )
        return;
      }
      context.showPointUse(result.mb_nick, price, () => {
        const mb_point = rootStore.getMe.mb_point
        if (Number(mb_point) < Number(price)) {
          context.showPointLack(1, price, () => {
            context.showPointPay()
          })
          return
        }
        context.post('pay/andata_buy', { dat_id: result.dat_id },
          response => {
            let mb = rootStore.getMe
            mb.mb_point = response.mb_point
            rootStore.signIn(mb)
            goResult(result)
          },
          true,
          err => {
            setTimeout(() => { context.showAlert(err.msg) }, 500)
          }
        )
      })
      return
    }
    goResult(result)
  }

  const onResultBj = (result) => {
    requestBjDataBuy(context, result, props, () => goResult(result));
  }

  const handlePageClick = (component) => {
    let nextPage = component.selected + 1
    setPage(prev => prev.map((it, idx) => { return idx === tabIndex ? nextPage : it }))
    getData(mbInfo.mb_id, nextPage, tabIndex)
  }

  const setBj = (idx) => {
    if (type === idx) return
    setType(idx)
    setMemberList(bjList)
  }

  const selectBj = (mb_id) => {
    if (mb_id == mbInfo.mb_id) return
    if (mb_id === 0) {
      props.history.push('/bj/list')
      return
    }
    setSelBj(mb_id)
    const bj = memberList.filter((item) => { return item.mb_id == mb_id })
    if (bj.length > 0) {
      props.history.replace(`/bj/detail/${bj[0].mb_id}`, { bjList: memberList });
      setInfo(bj[0])
      getData(bj[0].mb_id, 1, tabIndex)
    }
  }

  const onDetail = (info) => {
    const idx = Number(info.mb_lv - 4)
    setBj(idx)
    let mb
    mb = memberList.filter((item) => { return item.mb_id == info.mb_id })
    if (mb.length > 0) {
      props.history.replace(`/bj/detail/${mb[0].mb_id}`, { bjList: memberList });
      setInfo(mb[0])
      getData(mb[0].mb_id, 1, tabIndex)
    }
  }


  const cates = [strings.wn_bj, strings.best_bj, strings.partner_bj]
  const cate = (type) => {
    return type === -1 ? cates[0] : cates[type]
  }

  return (
    <>
      {
        loaded &&
        <React.Fragment>
          <MetaTags
            title={`위니 스포츠 | ${mbInfo.mb_nick + ' ' + strings.bj}`}
            description={`${mbInfo.mb_intro} | ${mbInfo.mb_detail}`}
            url={window.location.href}
            image={fphoto(mbInfo.mb_photo, 'member', MaleUrl)}
          />
          <div className='content-container'>
            <SidebarLeft type={1} bjList={memberList} onBJ={(info) => { onDetail(info) }} history={props.history} />
            <div className='im-container'>
              <PageSubHeader className={'sm-none'} pageName={cate(type)} pageMenu1={strings.main} pageMenu2={strings.bj_data} pageMenu={cate(type)} />
              <div className='sm-inherit'>
                <div className='d-flex align-items-center'>
                  <div className={'sm-fs-20 f-b cursor-point'}>{cates[0]}</div>
                </div>
              </div>
              <select className='form-control sm-inherit custom_select mt-15' value={selBj} onChange={(e) => { selectBj(parseInt(e.target.value)) }}>
                <option value={0}>{strings.all}</option>
                {memberList && memberList.map((it, idx) => { return (<option value={it.mb_id} key={idx}>{it.mb_nick}</option>) })}
              </select>
              <div className='bj-detail-area mt-30 sm-mt-15' style={{ maxWidth: '1024px' }}>
                <div className='flex-full'>
                  <div className='winee-bj-detail-item-area'>
                    <div className='winee-bj-item-profile-area'>
                      <div className='profile-image-box'>
                        <img className='w-100 h-100' src={fphoto(mbInfo.mb_photo, 'member', MaleUrl)} alt={''} />
                      </div>
                      <div style={{ display: 'flex', width: '100%' }}>
                        <div className='profile-card-box'>
                          <div className='profile-name'>{mbInfo.mb_nick + ' ' + strings.bj}{mbInfo.mb_new == 1 && <img className='icon_new' src='/assets/image/new.png' alt='' />}</div>
                          <div className='profile-intro mt-5'>{mbInfo.mb_intro}</div>
                          {
                            mbInfo.preview_dat &&
                            <div className={'profile-bottom-btn-area sm-none '}>
                              <ConfirmButton enabled={true} className={'preview fs-15 sm-fs-12 f-m sm-none'} text={strings.preview} onClick={() => goPreview(mbInfo.preview_dat)} />
                            </div>
                          }
                        </div>
                        <div className='profile-like-btn-area sm-none'>
                          <div className='profile-btn btn-bj-like-inner cursor-point d-center' onClick={onLike}>
                            <img className='star-img' src={mbInfo.mb_is_like === 1 ? '/assets/image/like_on.png' : '/assets/image/like.png'} alt='' />
                            <div className='fs-12 f-m ml-12 sm-none'>{strings.add_like}</div>
                          </div>
                        </div>
                        <div className='sm-inherit cursor-point' onClick={onLike}>
                          <img className='star-img' style={{ width: "28px", height: "28px" }} src={mbInfo.mb_is_like === 1 ? '/assets/image/like_on.png' : '/assets/image/like.png'} alt='' />
                        </div>
                      </div>
                    </div>
                    {
                      mbInfo.preview_dat &&
                      <div className={'sm-inherit'}>
                        <ConfirmButton enabled={true} className={'text-line btn-bottom fs-15 f-m d-center border-radius-8'} text={strings.preview} onClick={() => goPreview(mbInfo.preview_dat)} />
                      </div>
                    }

                    {
                      mbInfo.mb_avgUpload &&
                      <div className='winee-period-info w-100'>
                        <div>{strings.intro_avg_upload}&nbsp;:&nbsp;<span className='f-b'>{mbInfo.mb_avgUpload}</span></div>
                      </div>
                    }

                    {/* <div>{strings.active_period}&nbsp;:&nbsp;{mbInfo.mb_createdat.dateFormat('YYYY.MM.DD')}</div> */}

                    <div className='winee-detail-intro-area'>
                      <div className='space-break' dangerouslySetInnerHTML={{ __html: htmlToText(mbInfo.mb_detail) }} />
                    </div>
                  </div>

                  {rootStore.isSignedIn && rootStore.getMe.mb_id != mbInfo.mb_id && mbInfo.readable_cnt > 0 && <div className='fs-18 f-b mt-20 color-fa2222'>{string.Format(strings.ticket_cnt, formatNumber(mbInfo.readable_cnt))}</div>}
                  {rootStore.isSignedIn && unlimitedViewPeriods && <div className='fs-18 f-b mt-20 color-fa2222'>{`${string.Format(strings.unlimited_view_date, customDateFormat(unlimitedViewPeriods.max_end_time))}`}</div>}
                </div>
                {/* <div className='ml-20 sm-ml-0 sm-mt-15 term-content-area bj-item-area mt-0 mb-0 position-relative'>
                  <div className='position-relative h-100'>
                    <div className='fs-20 sm-fs-16 f-b color-3a3335'>{strings.product_buy}
                      {rootStore.isSignedIn && rootStore.getMe.mb_id != mbInfo.mb_id && <div className='fs-16 f-b mt-12 color-fa2222'>{string.Format(strings.ticket_cnt_short, formatNumber(mbInfo.readable_cnt))}</div>}
                    </div>
                    <ItemProduct
                      className={'mt-18 sm-mt-14'}
                      list={itemList}
                      selected={itemIndex}
                      onClick={(idx) => { setItemIndex(idx) }}
                    />
                    <div className='fs-15 color-4c4c4d mt-34 sm-mt-30 space-break'>{mbInfo.bj_note}</div>
                    {itemList.length > 0 && (rootStore.getMe?.mb_id ?? 0) != mbInfo.mb_id && <ConfirmButton enabled={true} className={'btn-bottom fs-15 f-m d-center mt-40'} onClick={onBuyItem} text={strings.buying} />}
                  </div>
                </div> */}
              </div>
              {
                itemList.length > 0 &&
                <>
                  <div className='fs-20 sm-fs-16 f-b mt-60 sm-mt-35 color-3a3335'>{strings.product_buy}</div>
                  <ItemProduct
                    className={'mt-18 sm-mt-14'}
                    list={itemList}
                    selected={itemIndex}
                    onClick={(prd) => { onBuyProduct(prd) }}
                  />
                </>

              }

              <div className='fs-20 sm-fs-16 f-b mt-60 sm-mt-35 color-3a3335'>{strings.analyst_data}</div>
              <TabHeader className={'mt-20 sm-mt-14 sm-none'} selected={tabIndex} tabs={tabList.map(item => item.customTitle || item.title)} onChange={(id) => { setTabIndex(id) }} />
              <select className='form-control sm-mt-15 sm-inherit custom_select' value={tabIndex} onChange={(e) => { setTabIndex(parseInt(e.target.value)) }}>
                {tabList.map((it, idx) => { return (<option value={idx} key={idx}>{it.title}</option>) })}
              </select>
              {tabList.map((it, idx) => {
                return (
                  <div key={idx} className={tabIndex === idx ? '' : 'hide'}>
                    <div className='shadow-div position-relative'>
                      {
                        isMobile ?
                          <div className='sm-mt-20 mb-40'>

                            <BjTableCard
                              header={it.header}
                              data={dataList[idx]}
                              onTitleClick={onResultBj}
                            />
                          </div>
                          :

                          <PerfectScrollbar className='tb-sale sm-mt-20 mb-40'>
                            <TableHeader className={'bg-white'} headers={it.header} />
                            {
                              it.table_type === "bj" &&
                              <BjTableRows
                                header={it.header}
                                data={dataList[idx]}
                                onTitleClick={onResultBj}
                                rowClick={true}
                              />

                            }
                            {
                              it.table_type === "daily" &&
                              <DailyTableRows
                                header={it.header}
                                data={dataList[idx]}
                                onTitleClick={onResultAnalyst}
                                rowClick={true}
                              />
                            }
                            {
                              it.table_type === "game" && dataList[idx].map((info, index) => {
                                return (
                                  <div key={index} className='tb-row clickable-row-highlight cursor-point' onClick={() => { onResultAnalyst(info, info.dat_po) }}>
                                    <TableCell
                                      value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                                      className={tbGameHeaders[0].class}
                                      center={tbGameHeaders[0].center}
                                      child={null}
                                    />
                                    <TableCellGameCate
                                      icon={info.sk_icon}
                                      name={info.sk_name}
                                      className={tbGameHeaders[1].class + ' d-flex'}
                                      center={tbGameHeaders[1].center}
                                      child={null}
                                    />
                                    <TableCell
                                      value={customDateFormat(info.dat_start)}
                                      className={tbGameHeaders[2].class}
                                      center={tbGameHeaders[2].center}
                                      child={null}
                                    />
                                    <TableCell
                                      value={info.home_name + ' : ' + info.away_name}
                                      className={tbGameHeaders[3].class}
                                      center={tbGameHeaders[3].center}
                                      child={null}
                                    />
                                    <TableCell
                                      value={info.dat_title}
                                      className={`${tbGameHeaders[4].class} hover-text-accent`}
                                      center={tbGameHeaders[4].center}
                                      child={drawTableTitleCell(info.dat_title, info.data_new)}
                                    />
                                    <TableCell
                                      value={info.mb_nick}
                                      className={tbGameHeaders[5].class}
                                      center={tbGameHeaders[5].center}
                                      child={null}
                                    />
                                    <TableCell
                                      value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
                                      color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color : strings.no_buy_color)}
                                      className={tbGameHeaders[6].class}
                                      center={tbGameHeaders[6].center}
                                      child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)}
                                    />
                                  </div>
                                )
                              })
                            }
                            {
                              it.table_type === "analyst" && dataList[idx].map((info, index) => {
                                return (
                                  <div key={index} className='tb-row clickable-row-highlight cursor-point' onClick={() => { onResultAnalyst(info, info.dat_po) }}>
                                    <TableCell
                                      value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                                      className={tbAnalystHeaders[0].class}
                                      center={tbAnalystHeaders[0].center}
                                      child={null}
                                    />
                                    <TableCell
                                      value={customDateFormat(info.dat_start)}
                                      className={tbAnalystHeaders[1].class}
                                      center={tbAnalystHeaders[1].center}
                                      child={null}
                                    />
                                    <TableCellGameCate
                                      icon={info.sk_icon}
                                      name={info.sk_name}
                                      className={tbGameHeaders[1].class + ' d-flex'}
                                      center={tbGameHeaders[1].center}
                                      child={null}
                                    />
                                    <TableCell
                                      value={info.dat_title}
                                      className={`${tbAnalystHeaders[3].class} hover-text-accent`}
                                      center={tbAnalystHeaders[3].center}
                                      child={drawTableTitleCell(info.dat_title, info.data_new)}
                                    />
                                    <TableCell
                                      value={info.mb_nick}
                                      className={tbAnalystHeaders[4].class}
                                      center={tbAnalystHeaders[4].center}
                                      child={null}
                                    />
                                    <TableCell
                                      value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
                                      color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color : strings.no_buy_color)}
                                      className={tbAnalystHeaders[5].class}
                                      center={tbAnalystHeaders[5].center}
                                      child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)}
                                    />
                                  </div>
                                )
                              })
                            }
                          </PerfectScrollbar>

                      }



                    </div>
                    {pageCount[idx] > 1 &&
                      <ReactPaginate
                        previousLabel={''}
                        nextLabel={''}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount[idx]}
                        marginPagesDisplayed={isMobile ? 1 : 2}
                        pageRangeDisplayed={isMobile ? 3 : 5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                      />
                    }
                  </div>
                )
              })}
            </div>
          </div>
        </React.Fragment>
      }
    </>
  )
})

export default withRouter(BjDetail)
